module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xpelv3-63bdd19a7adec0405104b02a848fd598.jpg";